var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-position": "top" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("routes.发车时间") } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.editRow.departureTime)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("routes.flowName") } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.editRow.flowDirectName)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("routes.departureTransferCenter"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.editRow.departTransferCenterName)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("routes.下一站流向") } },
                        [_c("span", [_vm._v(_vm._s(_vm.editRow.nextSiteName))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("routes.DepartureTimeRange") },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.editRow.shipmentTimeScope)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("routes.NumberBagsSent"), name: "1" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                      textAlign: "center",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.bagNumber"),
                      prop: "bagNumber",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("routes.LatestOperationInThisArea"),
                      prop: "operateType",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("routes.LatestOperationTimeInThisArea"),
                      prop: "operateTime",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("routes.WhetherToLeave"),
                      prop: "leaveSite",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label:
                  _vm.$t("routes.NumberItemsToBeSent") +
                  "(" +
                  _vm.$t("placeOrder.Normal") +
                  ")",
                name: "2",
              },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                      textAlign: "center",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                      prop: "waybillNumber",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.nowOperating"),
                      prop: "operateType",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.nowOperatingTime"),
                      prop: "operateTime",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("routes.IsThisAreaLoading"),
                      prop: "leaveSite",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label:
                  _vm.$t("routes.NumberItemsToBeSent") +
                  "(" +
                  _vm.$t("placeOrder.big01") +
                  ")",
                name: "3",
              },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                      textAlign: "center",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                      prop: "waybillNumber",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.nowOperating"),
                      prop: "operateType",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.nowOperatingTime"),
                      prop: "operateTime",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("routes.IsThisAreaLoading"),
                      prop: "leaveSite",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { margin: "20px 0", "text-align": "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 50, 100, 200, 400],
          total: _vm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "update:currentPage": function ($event) {
            return _vm.$set(_vm.queryForm, "pageNumber", $event)
          },
          "update:current-page": function ($event) {
            return _vm.$set(_vm.queryForm, "pageNumber", $event)
          },
          "update:pageSize": function ($event) {
            return _vm.$set(_vm.queryForm, "pageSize", $event)
          },
          "update:page-size": function ($event) {
            return _vm.$set(_vm.queryForm, "pageSize", $event)
          },
          "size-change": _vm.detailSizeChange,
          "current-change": _vm.detailCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }